import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingBlurFaceInPhotoConfig } from '@/data/landingConfig/landingBlurFaceInPhotoConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_BlurFaceInPhoto } from './schemaObject';

interface Props {}

const BlurFaceInPhoto: React.FC<Props> = () => (
	<>
		<AggregateSchema schema={schemaObject_BlurFaceInPhoto} />
		<LandingTemplate
			data={landingBlurFaceInPhotoConfig}
			funnelLinkService={GenerateLandingLinkService.funnelBlur()}
		/>
	</>
);

export default BlurFaceInPhoto;
